/**
 * CriteriaLevel
 */
import React from 'react';
import clsx from 'clsx';
import { Link as LinkBase } from 'ui-component-library/base';
import { Transition } from 'react-transition-group';
/** Main description for this component. */
var CriteriaLevel = function (_a) {
    var title = _a.title, url = _a.url, criteriaLevelId = _a.criteriaLevelId, _b = _a.expanded, expanded = _b === void 0 ? false : _b, _c = _a.active, active = _c === void 0 ? false : _c, _d = _a.LinkComponent, LinkComponent = _d === void 0 ? LinkBase : _d, children = _a.children;
    var Link = LinkComponent;
    return (React.createElement("div", { className: clsx('md:flex-1 criteria-level-select-border', active && 'bg-greyLighter') },
        React.createElement(Link, { className: clsx('block py-2 criteria-level-select-border text-h3 text-center text-black', active && 'bg-teal text-white'), to: url }, title),
        React.createElement(Transition, { in: expanded, timeout: 400 }, function (state) { return (React.createElement("div", { id: criteriaLevelId, hidden: state === 'exited', className: clsx('p-4', state === 'exiting' ? 'animate-fade-out' : 'animate-fade-in') }, children)); })));
};
export default CriteriaLevel;
